import React, { useState, useEffect } from "react";
import {simpleFetch} from "../../../utils/helpsers";
import Grid from '@mui/material/Grid';
import DataGridTable from "../../../components/organisms/Table/DataGridTable";
import LayoutPage from "../../../templates/Layout/LayoutPage";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import ReportButtons from "../../../components/organisms/BugReport/ReportButtons";
import Button from '@mui/material/Button';
import {TabsStyles} from "../../cruds/Cruds.styles";
import Box from "@mui/material/Box";
import BoardBuilder from "../../../components/organisms/BoardBuilder/BoardBuilder";
import { DataViewerStyles } from "./DataViewer.styles";

/**
 *
 * @param {object} data
 *  The columns/rows fetched by district.
 * @returns {Object}
 *  The same object structure but updated date values.
 */
const normalizeData = (data) => {
    data[0].columns = data[0].columns.map((item) => {
        if (item.field === "election_date") {
            return { ...item, type: "date" };
        } else {
            return item;
        }
    });

    data[0].rows = data[0].rows.map(item => {
        // iterating to convert array to string values and keep sort functionality.
        Object.keys(item).forEach(key => {
            if(Array.isArray(item[key])) {
                item[key] = (item[key]).join(', ');
            }
        })
        return({
            ...item,
            election_date: new Date(item.election_date),
            source: item.source ? item.source["apa_ref"] : null,
        })
    });

    return data[0];
};

function DataViewer() {
    //const [comparisonGroupOptions, setComparisonGroupOptions] = useState([]);

    // Object value/label from select component
    const [districtInfo, setDistrictInfo] = useState(null);
    const [year, setYear] = useState({});
    const [boardData, setBoardData] = useState();

    const [displayHvd, setDisplayHvd] = useState();
    const [metadataHvd, setMetadataHvd] = useState();
    const [storageHvd, setStorageHvd] = useState();


    const [viewer, setViewer] = useState();
    const [currentQuery, setCurrentQuery] = useState();

    // User session metadata and data
    const { user } = useAuth0();
    const metadata = user[`${process.env.REACT_APP_AUTH0_KEY}/district`];
    const enabledShare = user[`${process.env.REACT_APP_AUTH0_KEY}/district`].enable_share;
    const role = user[`${process.env.REACT_APP_AUTH0_KEY}/role`];

  const navigate = useNavigate();

    useEffect(() => {
        if (role === "api_user" && !enabledShare) {
            navigate("/AccessDenied", { replace: true });
        }
        else if (metadata) {
            const userSessionType = metadata.hasOwnProperty("sessionType")
                ? metadata.sessionType
                : "forbidden";
            switch (userSessionType) {
                case "district-access":
                    const districtData = {
                        value: parseInt(metadata.districtIrn),
                        label: metadata.districtLabel,
                    };
                    setDistrictInfo(districtData);
                    break;
                case "full-access":
                    window.localStorage.setItem("session-type", "full-access");
                    break;
                case 'multiple-district-access':
                    window.localStorage.setItem('session-type', 'multiple-district-access');
                    break;
                case "forbidden":
                    navigate("/AccessDenied", { replace: true });
                    break;
                default:
                    navigate("/AccessDenied", { replace: true });
                    break;
            }
        } else {
            navigate("/AccessDenied", { replace: true });
        }
    }, [navigate, user, metadata, role, enabledShare]);

    useEffect(() => {
        if (boardData) {
          setDistrictInfo(boardData.referenceDistrict);
          setYear(boardData.year);
        }
      }, [boardData]);
      
      useEffect(() => {
        let ref = districtInfo?.value;

        let urlDisplay = `${process.env.REACT_APP_API_URL}/rpc/hvd_display`;
        let urlMetadata =
            `${process.env.REACT_APP_API_URL}/rpc/hvd_metadata?_year='${year.value}'`;
        let urlStorage =
            `${process.env.REACT_APP_API_URL}/rpc/hvd_storage?_irn=` + ref + "&_year=" + year.value;
  
        setCurrentQuery({district: districtInfo?.label, year: year?.value});
  
        simpleFetch(urlDisplay).then((data) => {
          if (data[0].rows && data[0].columns) {
            setDisplayHvd(normalizeData(data));
            setViewer('storage');
            let tabs = document.querySelectorAll('.GroupsButtons__item');
            tabs.forEach(tab => {
              tab.classList.remove('active');
              if (tab.classList.contains('tab-storage')) {
                tab.classList.add('active');
              };
            });
          }
        });
  
        simpleFetch(urlMetadata).then((data) => {
          if (data[0].rows && data[0].columns) {
            setMetadataHvd(normalizeData(data));
          }
        });
  
        if (ref && year.value) {
          simpleFetch(urlStorage).then((data) => {
            if (data[0].rows && data[0].columns) {
              setStorageHvd(normalizeData(data));
            }
          });
        }
        }, [districtInfo?.label, districtInfo?.value, year.value]);

    const updateTab = (e)=> {
        let tabs = document.querySelectorAll('.GroupsButtons__item');
        tabs.forEach(button => button.classList.remove('active'));
        e.currentTarget.classList.add('active');
    }

    const topContentElement = (
        <Grid container spacing={1} alignItems="center" sx={DataViewerStyles}>
            <Grid item xs={12}>
            <BoardBuilder yearEnabled={true} boardData={setBoardData}/>
            </Grid>
        </Grid>
    )

    return (
        <LayoutPage
            pageTitle="Data Viewer"
            description="Shows the raw data in the database"
            type="dashboard"
            customClass="data-viewer"
            topContent={topContentElement}
        >
            <section className="levy__cards">
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                >
                    {
                        (displayHvd || metadataHvd || storageHvd) &&

                            <Grid item xs={12} >
                                <Box className="DataViewer__options GroupsButtons" sx={TabsStyles}>
                                    {
                                        storageHvd &&
                                            <Button variant="text"
                                                onClick={(e) => {
                                                  setViewer('storage');
                                                  updateTab(e);
                                                }}
                                                className="DataViewer__btn GroupsButtons__item tab-storage active">Storage</Button>

                                    }
                                    {
                                        displayHvd && Object.keys(year).length > 0  &&
                                            <Button variant="text"
                                                onClick={(e) => {
                                                  setViewer('display');
                                                  updateTab(e);
                                                }}
                                                className="DataViewer__btn tab-display GroupsButtons__item">Display</Button>
                                    }
                                    {
                                        metadataHvd &&
                                            <Button variant="text"
                                                onClick={(e) => {
                                                  setViewer('metadata');
                                                  updateTab(e);
                                                }}
                                                className="DataViewer__btn tab-metadata GroupsButtons__item">Metadata</Button>
                                    }
                                </Box>
                            </Grid>
                        }
                    {
                        displayHvd && viewer === 'display' && (
                            <Grid item xs={12} className="table-data">
                                <h2>Display</h2><span>{currentQuery.district} - {currentQuery.year === 'MCD' ? `2026 (Most Current Data)` : currentQuery.year }</span>
                                <DataGridTable
                                    columns={displayHvd.columns}
                                    rows={displayHvd.rows}
                                    sortField={"id"}
                                    sortOrder={"asc"}
                                    customStyles={{
                                        '@media print': {
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"]': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"] .MuiDataGrid-columnHeader': {
                                                minWidth: "inherit !important",
                                                flex: "1",
                                            },
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"] .MuiDataGrid-columnHeaderTitleContainerContent': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-virtualScrollerRenderZone': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-row': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-row .MuiDataGrid-cell': {
                                                minWidth: "inherit !important",
                                                flex: "1",
                                                whiteSpace: "break-spaces !important",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                        )
                    }
                    {
                        metadataHvd && viewer === 'metadata' &&
                        (
                           
                            <Grid item xs={12} className="table-data">
                                <h2>Metadata</h2><span>{currentQuery.district} - {currentQuery.year === 'MCD' ? `2026 (Most Current Data)` : currentQuery.year }</span>
                                <DataGridTable
                                    columns={metadataHvd.columns.map((item) => ({
                                        ...item,
                                        minWidth: 250,
                                      }))}
                                    rows={metadataHvd.rows}
                                    sortField={"id"}
                                    sortOrder={"asc"}
                                    customStyles={{
                                        '@media print': {
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"]': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"] .MuiDataGrid-columnHeader': {
                                                minWidth: "inherit !important",
                                                flex: "1",
                                            },
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"] .MuiDataGrid-columnHeaderTitleContainerContent': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-virtualScrollerRenderZone': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-row': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-row .MuiDataGrid-cell': {
                                                minWidth: "inherit !important",
                                                flex: "1",
                                                whiteSpace: "break-spaces !important",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                        )
                    }
                    {
                        storageHvd && districtInfo && viewer === 'storage' && (
                            <Grid item xs={12} className="table-data">
                                <h2>Storage</h2><span>{currentQuery.district} - {currentQuery.year === 'MCD' ? `2026 (Most Current Data)` : currentQuery.year }</span>
                                <DataGridTable
                                    columns={storageHvd.columns}
                                    rows={storageHvd.rows}
                                    sortField={"id"}
                                    sortOrder={"asc"}
                                    customStyles={{
                                        '@media print': {
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"]': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"] .MuiDataGrid-columnHeader': {
                                                minWidth: "inherit !important",
                                                flex: "1",
                                            },
                                            '& .MuiDataGrid-columnHeadersInner div[role="row"] .MuiDataGrid-columnHeaderTitleContainerContent': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-virtualScrollerRenderZone': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-row': {
                                                width: "100% !important",
                                            },
                                            '& .MuiDataGrid-row .MuiDataGrid-cell': {
                                                minWidth: "inherit !important",
                                                flex: "1",
                                                whiteSpace: "break-spaces !important",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                        )
                    }
                </Grid>
            </section>
            <ReportButtons
                boardType={"Data Viewer"}
                collectedData={{
                    districtInfo: districtInfo,
                    fileYear: year,
                }}
            />
        </LayoutPage>
    );
}

export default DataViewer;
